import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const B2BSlide = ({ img, alt = '', title = '', text = '', link_text = '', href = '' }) => {
  return (
    <View>
      <Top>
        <Image src={img} alt={alt} />
        <Title>{title}</Title>
        <Text>{text}</Text>
      </Top>
      <Bottom>
        <Link href={href} target="_blank">
          {link_text}
        </Link>
      </Bottom>
    </View>
  );
};

const View = styled.div`
  background-color: ${Colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  padding: 30px 22px;

  @media ${Points.laptop_wide} {
    padding: 40px 30px;
  }
`;
const Top = styled.div`
  flex-grow: 1;
`;
const Image = styled.img`
  margin-bottom: 30px;
  max-width: 100%;
  max-height: 200px;

  @media ${Points.laptop_wide} {
    margin-bottom: 40px;
  }
`;
const Title = styled.div`
  font-size: 18px;
  line-height: 1.1;
  margin-bottom: 20px;
  color: ${Colors.main_black};

  @media ${Points.tablet_landscape} {
    font-size: 20px;
  }

  @media ${Points.laptop_wide} {
    font-size: 24px;
  }
`;
const Text = styled.div`
  font-size: 16px;
  line-height: 1.3;
  color: ${Colors.main_black};

  @media ${Points.laptop_wide} {
    font-size: 18px;
  }
`;
const Bottom = styled.div`
  margin-top: 20px;
`;
const Link = styled.a`
  font-size: 16px;
  text-decoration: none;
  color: ${Colors.main_blue};
  line-height: 1.3;

  &:hover {
    color: ${Colors.blue_500};
  }

  @media ${Points.laptop_wide} {
    font-size: 18px;
  }
`;
